import { gql } from '@apollo/client';

export const GET_MASTER_DATA_BOUTIQUES = gql`
  query masterDataBoutiques($where: MasterDataBoutiqueBoolExp, $orderBy: [MasterDataBoutiqueOrderByExp!]) {
    masterDataBoutiques(order_by: $orderBy, where: $where) {
      _id
      address {
        countryCode
      }
      boutiqueId
      name
      type
    }
  }
`;

export const GET_BOUTIQUES = gql`
  query findBoutiquesQuery($input: FindBoutiquesQueryInput!) {
    result: findBoutiquesQuery(input: $input) {
      data {
        value {
          _id
          name
          createdBy
          country {
            _id
          }
          admins {
            _id
          }
          boutique {
            address {
              countryCode
            }
            name
            type
          }
          coverImage {
            urlRegular
          }
        }
      }
      pagination {
        currentPage
        itemsPerPage
        totalPages
        totalItems
      }
    }
  }
`;

export const GET_BOUTIQUE = gql`
  query boutique($_id: String!) {
    boutique(_id: $_id) {
      _id
      name
      createdAt
      createdBy
      boutique {
        _id
        name
        boutiqueId
        timezone
        masterclasses
      }
      country {
        _id
        translations {
          code
          name
        }
      }
      admins {
        _id
        name
      }
      language {
        _id
        name
      }
      coverImage {
        unsplashId
        unsplashLink
        unsplashUserName
        unsplashUserUrl
        urlFull
        urlRegular
      }
      widgets {
        _id
        content {
          type
        }
        layouts {
          desktop {
            height
            positionX
            positionY
            preCollapseHeight
            width
          }
          mobile {
            height
            positionX
            positionY
            preCollapseHeight
            width
          }
        }
        movable
        resizable
        title
      }
    }
  }
`;

export const UPDATE_BOUTIQUE = gql`
  mutation updateOneBoutique($query: BoutiqueQueryInput!, $set: BoutiqueUpdateInput!) {
    result: updateOneBoutique(query: $query, set: $set) {
      value {
        _id
      }
    }
  }
`;
